/* eslint max-classes-per-file: 0 */

import {
  Report,
  Report as Collection,
} from '@/typings/api/Report'

import { Fabric } from '@/store/createCrudModule'
import { LKReportsAdapter } from './LKReportsAdapter'


export const fabric = Fabric<Report, Collection>()

type S = LKReportState
type G = LKReportGetters
type M = LKReportMutations
type A = LKReportActions


export class LKReportState extends fabric.State {
}

export class LKReportGetters extends fabric.Getters<S> {
}

export class LKReportMutations extends fabric.Mutations<S> {
  public updateList(data: Report) {
    const { list } = this.state
    if (!list) return

    const index = list.findIndex((_) => _.id === data.id)
    if (index === -1) return

    const oldData = list[index]
    list.splice(index, 1, { ...oldData, ...data })
  }
}

export class LKReportActions extends fabric.Actions<S, G, M, A> {
  protected readonly adapter = new LKReportsAdapter();

  protected readonly idName = 'id';

  public async getOneAndUpdateList({ id }: { id: number }) {
    const data = await this.actions.getOne({ id })
    if (data) this.mutations.updateList(data)
  }

  public async restart({ id }: { id: number }) {
    await this.adapter.api.restart(id)
    return this.getOneAndUpdateList({ id })
  }

  public getData({ id }: { id: number }) {
    return this.adapter.api.getData(id)
  }
}
